export default "__VITE_ASSET__21cf75c3__"